import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from '../components/base-button/Component.js';

var defaultColors = {"primary":"button__primary_19fws","loader":"button__loader_19fws","secondary":"button__secondary_19fws","text":"button__text_19fws","ghost":"button__ghost_19fws","component":"button__component_19fws","loading":"button__loading_19fws","outlined":"button__outlined_19fws","tertiary":"button__tertiary_19fws","transparent":"button__transparent_19fws","link":"button__link_19fws"};
require('./default.desktop.css')

var styles = {"size-32":"button__size-32_zcxsx","size-40":"button__size-40_zcxsx","size-48":"button__size-48_zcxsx","size-56":"button__size-56_zcxsx","size-64":"button__size-64_zcxsx","size-72":"button__size-72_zcxsx"};
require('./desktop.css')

var invertedColors = {"primary":"button__primary_1mp4j","loader":"button__loader_1mp4j","secondary":"button__secondary_1mp4j","text":"button__text_1mp4j","ghost":"button__ghost_1mp4j","component":"button__component_1mp4j","loading":"button__loading_1mp4j","outlined":"button__outlined_1mp4j","tertiary":"button__tertiary_1mp4j","transparent":"button__transparent_1mp4j","link":"button__link_1mp4j"};
require('./inverted.desktop.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, styles: styles, colorStylesMap: colorStyles }))); });

export { ButtonDesktop };
